import { AuthApiBaseUrl } from "./baseUrls";
import { fetchWrapper } from "./fetchWrapper";

export async function verifyEmail(token: string): Promise<{token: string}> {
    const url = `${AuthApiBaseUrl}/verifyEmail?token=${token}`;
    const verifyEmailResponse = await fetchWrapper(url, {method: 'GET'});
    return verifyEmailResponse.data as {token: string};
}
